import request from '@/router/axios'

export function fetchList (query) {
  return request({
    url: '/admin/admin/role/page',
    method: 'get',
    params: query
  })
}

export function deptRoleList () {
  return request({
    url: '/admin/admin/role/list',
    method: 'get'
  })
}

export function getObj (id) {
  return request({
    url: '/admin/admin/role/' + id,
    method: 'get'
  })
}

export function addObj (obj) {
  return request({
    url: '/admin/admin/role',
    method: 'post',
    data: obj
  })
}

export function putObj (obj) {
  return request({
    url: '/admin/admin/role',
    method: 'put',
    data: obj
  })
}

export function delObj (id) {
  return request({
    url: '/admin/admin/role/' + id,
    method: 'delete'
  })
}

export function permissionUpd (roleId, menuIds) {
  return request({
    url: '/admin/admin/role/menu',
    method: 'put',
    params: {
      roleId: roleId,
      menuIds: menuIds
    }
  })
}

export function fetchRoleTree (roleName) {
  return request({
    url: '/admin/admin/menu/tree/' + roleName,
    method: 'get'
  })
}
